// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pagination[data-v-34f0c030]{display:flex;align-items:center;justify-content:center;margin:30px 0}#pagination>.pageFoot[data-v-34f0c030]{font-size:14px;color:#8590a6}", ""]);
// Exports
module.exports = exports;
